import * as Anvil2 from '@servicetitan/anvil2';
import { FC, PropsWithChildren } from 'react';

export const Anvil2Providers: FC<{ portalAnvilContainer: HTMLDivElement } & PropsWithChildren> = ({
    portalAnvilContainer,
    children,
}) => {
    if (Anvil2.PortalProvider === undefined) {
        return children;
    }

    return <Anvil2.PortalProvider root={portalAnvilContainer}>{children}</Anvil2.PortalProvider>;
};
